import { Map } from 'immutable';
import * as actions from '../utils/Constants';

const excludedActions = ['UPDATE_USER_PERSON_ADDRESS_PENDING']

export default (state = getInitialState(), action) => {

    switch (action.type) {

        case actions.SHOW_SPINNER:
            return state.set('isLoading', true);

        case actions.HIDE_SPINNER:
        case actions.ERROR:
            return state.set('isLoading', false);

        default:
            {
                if (!excludedActions.includes(action.type) && action.type.includes(actions.PENDING)) {

                    return state.withMutations(mut => {
                        mut.set('isLoading', true);
                        mut.get('pendingActions').push(action.type.replace(actions.PENDING, ''));
                    });

                }
                else if (action.type.includes(actions.FULFILLED) || action.type.includes(actions.REJECTED)) {
                    const actionName = action.type.replace(actions.PENDING, '').replace(actions.FULFILLED, '');
                    return state.withMutations(mut => {
                        
                        mut.update('pendingActions', actions => actions.filter(f => f !== actionName));

                        if (mut.get('pendingActions').length === 0)
                            mut.set('isLoading', false);
                    });
                }
                else if (action.type === '@@router/LOCATION_CHANGE') {
                    switch (action.payload.location.pathname) {
                        case '/admin':
                            return state.set('moduleName', 'Admin');
                        case '/courses':
                            return state.set('moduleName', 'Courses');
                        case '/course':
                            return state.set('moduleName', 'New Course');
                        case '/programs':
                            return state.set('moduleName', 'Programs');
                        case '/contacts':
                            return state.set('moduleName', 'Contacts');
                        case '/grants':
                            return state.set('moduleName', 'Grants');
                        case '/home':
                            return state.set('moduleName', 'Home');
                        case '/jurisdictions':
                            return state.set('moduleName', 'Jurisdictions');
                        case '/projects':
                            return state.set('moduleName', 'Projects');
                        case '/project':
                            return state.set('moduleName', 'New Project');
                        case '/trainings':
                            return state.set('moduleName', 'Trainings');
                        case '/trainingTypes':
                            return state.set('moduleName', 'Training Types');
                        case '/trainingType':
                            return state.set('moduleName', 'New Training Type');
                        case '/users':
                            return state.set('moduleName', 'Users');
                        case '/user':
                            return state.set('moduleName', 'New User');
                        case '/sessions':
                            return state.set('moduleName', 'Sessions');
                        case '/reports':
                            return state.set('moduleName', 'Reports');
                        case '/session':
                            return state.set('moduleName', 'New Session');
                        default: {
                            if (action.payload.location.pathname.includes('/user/'))
                                return state.set('moduleName', 'Users');
                            if (action.payload.location.pathname.includes('/project/'))
                                return state.set('moduleName', 'Projects');
                            else if (action.payload.location.pathname.includes('/course/'))
                                return state.set('moduleName', 'Courses');
                            else if (action.payload.location.pathname.includes('/program/'))
                                return state.set('moduleName', 'Programs');
                            else if (action.payload.location.pathname.includes('/grant/'))
                                return state.set('moduleName', 'Grants');
                            else if (action.payload.location.pathname.includes('/session/'))
                                return state.set('moduleName', 'Sessions');
                            else if (action.payload.location.pathname.includes('/training/'))
                                return state.set('moduleName', 'Trainings');
                            else if (action.payload.location.pathname.includes('/jurisdiction/'))
                                return state.set('moduleName', 'Jurisdictions');
                            else if (action.payload.location.pathname.includes('/trainingTypes/'))
                                return state.set('moduleName', 'TrainingTypes');
                            else
                                return state.set('moduleName', 'Unknown Module');
                        }
                    }
                }

            }
    }

    return state;
}

const getInitialState = () => {
    return Map({
        isLoading: false,
        pendingActions: []
    });
};